import {
  DiJava,
  DiNodejs,
  DiJavascript1,
  DiReact,
  DiBootstrap,
  DiHtml5,
  DiPython,
  DiLinux,
  DiMongodb,
  DiGit,
  DiGithub,
} from 'react-icons/di';

import {
  SiSpringboot,
  SiDocker,
  SiKubernetes,
  SiAmazonaws,
  SiMongodb,
  SiRedis,
  SiApachekafka,
  SiPrometheus,
  SiGrafana,
  SiPostgresql,
} from 'react-icons/si';

import CursorIconImg from '../Assets/cursor-ai.png';
import { CgCPlusPlus } from 'react-icons/cg';

const CursorIcon = () => (
  <img
    src={CursorIconImg}
    alt="Cursor AI"
    width={80}
    height={80}
  />
);

export const TECH_STACK = [
  { icon: DiJava, label: 'Java' },
  { icon: SiSpringboot, label: 'Spring Boot' },
  { icon: SiDocker, label: 'Docker' },
  { icon: SiKubernetes, label: 'Kubernetes' },
  { icon: SiAmazonaws, label: 'AWS' },
  { icon: SiMongodb, label: 'MongoDB' },
    { icon: SiPostgresql, label: 'PostgreSQL' },
  { icon: SiRedis, label: 'Redis' },
  { icon: SiApachekafka, label: 'Kafka' },
  { icon: SiPrometheus, label: 'Prometheus' },
  { icon: SiGrafana, label: 'Grafana' },
  { icon: DiPython, label: 'Python' },
  { icon: DiNodejs, label: 'Node.js' },
  { icon: DiReact, label: 'React' },
  { icon: DiJavascript1, label: 'JavaScript' },
  { icon: CursorIcon, label: 'Cursor AI' },
  { icon: DiGit, label: 'Git' },
];
